import RelatedContentCard from '@rsa-digital/evo-shared-components/components/RelatedContent/RelatedContentCard';
import { graphql } from 'gatsby';
import React from 'react';
import {
  processImageAsset,
  processReadMoreLink,
  unwrapSingleton,
} from 'helpers/csTypeProcessors';
import { handleAndTrackLinkClick } from 'helpers/navigation';
import { RelatedContentCardProps } from '../types';

export const query = graphql`
  fragment RelatedContentCardBlock on cs__related_content_card {
    url
    image {
      ...Asset
    }
    heading
    subheading
    body
    read_time
    read_time_text
    read_time_icon {
      ...Icon
    }
    read_more {
      url
      text
      open_in_new_tab
    }
    max_lines
  }
`;

const RelatedContentCardBlock: React.FC<RelatedContentCardProps> = ({
  related_content_card,
}) => (
  <RelatedContentCard
    url={related_content_card.url}
    onClick={handleAndTrackLinkClick(
      related_content_card.url,
      'relatedContentCard',
      related_content_card.heading
    )}
    image={processImageAsset(related_content_card.image)}
    heading={related_content_card.heading}
    subheading={related_content_card.subheading ?? undefined}
    body={related_content_card.body ?? undefined}
    readTime={related_content_card.read_time ?? undefined}
    readTimeText={related_content_card.read_time_text ?? undefined}
    readTimeIcon={unwrapSingleton(related_content_card.read_time_icon)?.icon_code}
    readMore={processReadMoreLink(related_content_card.read_more)}
    maxLines={related_content_card.max_lines ?? undefined}
  />
);

export default React.memo(RelatedContentCardBlock);
